module.exports = __webpack_public_path__ + "img/card-billing-history.68895c6b.svg";